import type { Page, Project } from '@scalar-org/entities/project'
import type { Theme } from '@scalar-org/entities/theme'

export enum Events {
  Initialize = 'initialize',
  ConfigChange = 'config-change',
  ConfigError = 'config-error',
  FileChange = 'file-change',
}

/** Used to send any additional parameters from the CLI to the client for config */
export type InitializeEvent = {
  type: Events.Initialize
  data: {
    proxy: string
  }
}

export type ConfigChangeEvent = {
  type: Events.ConfigChange
  data: {
    project: Project
    theme: Theme
  }
}

export type ConfigErrorEvent = {
  type: Events.ConfigError
  data: {
    errors: string[]
  }
}

type ReferenceFileChange = {
  uid: string
  versionUid: string
}

type PageFileChange = {
  uid: string
  versionUid: string
  guideUid: string
  page: Page
}

export type FileChangeEvent = {
  type: Events.FileChange
  data: ReferenceFileChange | PageFileChange
}

export type SocketEvent =
  | InitializeEvent
  | ConfigChangeEvent
  | ConfigErrorEvent
  | FileChangeEvent
